import React from 'react'
import { LaTercera } from '@labcon/copesa-logos'
import { Link } from 'gatsby'
import styled from 'styled-components'
import Menu from './Menu'

const StyledHeader = styled.header`
  backdrop-filter: saturate(200%) blur(5px);
  background-color: rgba(0, 0, 0, 0.9);
`

const menu = [
  { name: 'Inicio', path: '/' },
  { name: 'Listas', path: '/listas/' },
  { name: 'Distritos', path: '/distritos/' },
  { name: 'Pueblos Originarios', path: '/pueblos-originarios/' },
]

const Header = () => (
  <StyledHeader className="fixed top-0 left-0 right-0 z-20 border-gray-300 border-solid shadow-md">
    <div className="container grid items-center h-16 grid-cols-12 px-4 mx-auto sm:px-4 lg:px-20">
      <div className="col-span-3 "></div>
      <div className="flex justify-center col-span-6">
        <Link to="/" className="" title="La Tercera">
          <LaTercera width="200" height="20" schema="light" />
        </Link>
      </div>
      <div className="col-span-3 justify-items-end">
        <Menu menu={menu} />
      </div>
    </div>
  </StyledHeader>
)

export default Header
